import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import axiosClient from "../../../AxiosClient";
import {
  AlertErrorMessage,
  AuthButton,
  Header,
  Footer,
} from "../../../Components";
import { loginSuccess } from "../../../Redux/SliceAuthAdmin";
import {
  get,
  storeInLocalStorage,
} from "../../../Services/LocalStorageService";

const AuthAdmin = () => {
  document.title = "Admin Login";

  const adminData = useSelector((state) => state.AuthAdmin);
  const navigate = useNavigate();
  console.log(adminData);

  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    if (adminData.isAuthenticated && get("TOKEN_ADMIN")) {
      navigate("/admin/dashboard");
    }
  }, [navigate, adminData.isAuthenticated]);

  const [DataForm, setDataForm] = useState({
    email: "Osgabc@gmail.com",
    password: "admin_password",
  });

  const [error, setError] = useState("");

  const HandleChangeData = (ev) => {
    const { name, value } = ev.target;
    setDataForm({ ...DataForm, [name]: value });
  };

  const HandleSubmit = (e) => {
    setLoading(true);
    e.preventDefault();
    axiosClient
      .post("/admin/login", DataForm)
      .then(({ data }) => {
        console.log({ data });
        dispatch(loginSuccess(data));

        storeInLocalStorage("TOKEN_ADMIN", data.token);
        setLoading(false);
        navigate("/admin/dashboard");
      })
      .catch((err) => {
        setLoading(false);
        if (err.response && err.response.status === 422) {
          setError(err.response.data.error);
        } else {
          console.log(err);
        }
      });
  };

  return (
    <>
      <div className="h-screen">
        <div className=""

          style={{
            height: '810px',
            backgroundImage: "url('/img/login-Signup-Banner.jpg')",
            backgroundSize: 'contain',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <Header />
          <div className="h-[41rem] flex justify-center items-center">
            <div className="w-[27rem] rounded-md bg-white pl-8 pt-7 pr-8 pb-7"
              style={{
                position: 'relative',
                right: '20%',
                top: '0',
                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
              }}>
              <div className="text-center">
                <div className="flex justify-center items-center">
                  <img src="/img/logo.svg" className="w-[123px]" alt="" />
                </div>
                <div className="mb-[14px]">
                  <h1 className="mt-4 text-[25px] font-medium text-gray-900">
                    Welcome to <span className="text-[#3d75ba]">Admin Management</span>
                  </h1>
                </div>
              </div>
              {error && <AlertErrorMessage message={error} />}
              <form className="relative p-5 pl-8 pr-8 space-y-5" onSubmit={HandleSubmit}>
                <div className="mb-[20px]">
                  <label
                    htmlFor="email"
                    className="block mb-1 text-xs font-medium text-gray-900 dark:text-white"
                  >
                    Email
                  </label>
                  <input
                    type="text"
                    id="email"
                    name="email"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full py-2 px-3 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder="exemple@gmail.com"
                    required
                    value={DataForm.email}
                    onChange={HandleChangeData}
                  />
                </div>

                <div className="mb-[20px]">
                  <label
                    htmlFor="Password"
                    className="block mb-1 text-xs font-medium text-gray-900 dark:text-white"
                  >
                    Password
                  </label>
                  <input
                    type="password"
                    id="Password"
                    value={DataForm.password}
                    name="password"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full py-2 px-3 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder="•••••••••"
                    required
                    onChange={HandleChangeData}
                  />
                </div>

                {/* Forgot Password */}
                <div className="mb-2">
                  <Link to="/forgot-password" className="flex flex-row-reverse">
                    <span className="text-medium tracking-wide text-[13px] text-blue-600">
                      Forgot your password?
                    </span>
                  </Link>
                </div>

                <div className="flex justify-center items-center w-full">
                  <AuthButton Text={"Login"} Loading={loading} />
                </div>
              </form>
            </div>
          </div>
          <Footer colorText="white" />
        </div>
      </div>
    </>
  );
};

export default AuthAdmin;
